import { Outlet, useLocation, useNavigate } from 'react-router';

import { Sidebar, Text } from '@thefarmersfront/kitchen';

import { SmartSearchPanelGroup } from '~/components/common';
import { Header } from '~/components/layout';

import { generateSidebarConfig } from '~/configs';
import type { TypeLogisticsType, TypeOwnerType } from '~/constants/common';

import styles from './Layout.module.scss';

type TypeLayoutProps = {
  ownerType: TypeOwnerType;
  logisticsTypes: TypeLogisticsType[];
};

const Layout = ({ ownerType, logisticsTypes }: TypeLayoutProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const menus = generateSidebarConfig(ownerType, logisticsTypes);

  const handleClickSidebarItem = (path: string) => {
    navigate(path);
  };

  return (
    <div className={styles['layout']}>
      <div className={styles['header-container']}>
        <Header />
      </div>
      <SmartSearchPanelGroup>
        <div className={styles['main-container']}>
          <Sidebar
            currentKey={pathname}
            menus={menus}
            onSelectItem={handleClickSidebarItem}
            bottomElement={
              <div className={styles['footer-container']}>
                <Text color="secondary" size="xsmall">
                  &#169; Kurly Corp.
                  <br />
                  All rights reserved.
                </Text>
              </div>
            }
          />
          <div className={styles['content-container']}>
            <div className={styles['page-wrapper']}>
              <Outlet />
            </div>
          </div>
        </div>
      </SmartSearchPanelGroup>
    </div>
  );
};

export default Layout;
